import { schema } from 'normalizr';

import { processDismissablePrompt } from '../strategies/dismissablePrompt';

const dismissablePromptSchema = new schema.Entity(
  'dismissablePrompts',
  {},
  { idAttribute: 'promptKey', processStrategy: processDismissablePrompt }
);

export type DismissablePromptsSchema = typeof dismissablePromptsSchema;
export const dismissablePromptsSchema = [dismissablePromptSchema];
